import React from "react";
import EventDetails from "../../common/components/EventDetails";

const roles = [
	{ name: "Line Judge", value: "lineJudge" },
	{ name: "Umpire", value: "umpire" }
];

const GameEventDetails = () => {
	return <EventDetails roles={roles} />;
};

export default GameEventDetails;
